// extracted by mini-css-extract-plugin
export default {"dot":"SlideShow_dot__5PF53","fade":"SlideShow_fade__ZLKK5","text":"SlideShow_text__s5HNr"};